<template>
  <section id="home_user_info">
    <div class="usr_home trans_box">
      <div class="left_usr_home ">
        <div class="flex-row row2">
          <div class="user_img_bg">
            <AvatarImage :src="authStore.userAvatar" alt="User Avatar"/>
          </div>
          <div class="flex-column">
            <div class="salut_box">
              <BaseImage src="/static/images/hello.svg" alt="Hello" />
              <p class="salutation">{{ $_translations.value.page_home_section_user_info_hello }}</p>
            </div>
            <p class="name">{{ authStore.userUsername  }}</p>
            <div class="flex-row progr">
              <BaseProgressBar :value="authStore.userNextLevelProgressPercentage" />
              <p class="progress_numb">{{ authStore.userNextLevelProgressText }}</p>
            </div>
          </div>

        </div>
        <div class="flex-row row3">
          <div class="bg_border lvl" @click="redirectTo('Levels')">
            <div class="flex-row">
              <BaseImage :src="authStore.userLevelIcon" alt="Level Image"/>
              <p>{{ $_translations.value.page_home_section_user_info_level }} {{ authStore.user.level || 1 }}</p>
            </div>
          </div>
          <div class="bg_border games not_clickable">
            <div class="flex-row">
              <BaseImage src="/static/images/games_left_yes.svg" alt="Games Left"/>
              <p>{{ authStore.user.gamesPlayed || 0 }}</p>
            </div>
          </div>
          <div v-if="!appSettingsStore.isPointsHidden" class="bg_border points not_clickable">
            <div class="flex-row">
              <BaseImage src="/static/images/points_1.svg" class=""/>
              <p>{{ authStore.user.totalPointsEarned }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import useAuthStore from '@/store/modules/auth.js';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseProgressBar from '@/components/bar/BaseProgressBar.vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';

const authStore = useAuthStore();
const appSettingsStore = useAppSettingsStore();

const { redirectTo } = usePageNavigationHook();
</script>
